export default {
  SphereLogo:
    "https://firebasestorage.googleapis.com/v0/b/sphereone-testing.appspot.com/o/spark-logo-ligth-mode.png?alt=media&token=d8abb42f-5406-4870-82e9-e892d873ed9d",
  SphereLogoBlack:
    "https://firebasestorage.googleapis.com/v0/b/sphereone-testing.appspot.com/o/sparkle-logo-dark-mode.png?alt=media&token=bed619e4-68ec-4df4-ae5b-2f287e2ca2c2",
};